{
  "required": "Obrigatório",
  "must_be_less_than": "Deve ter {{ characters }} caracteres ou menos",
  "problem_with_our_servers": "Houve um problema com nossos servidores. Tente novamente mais tarde.",
  "problem_with_our_servers_code": "Houve um problema com nossos servidores. O código de erro é {{ code }}",
  "problem_with_data_submitted": "Houve um problema com os dados enviados ao servidor",
  "connecting_with_our_servers": "Houve um problema na conexão com nossos servidores. Tente novamente mais tarde.",
  "timeout_connecting_servers": "Sua solicitação atingiu o tempo limite. Por favor, tente novamente.",
  "internet_connection_issue": "Há um problema com a conexão com o servidor. Verifique sua conexão com a internet",
  "copy_code": "Copiar código",
  "polygon_edit_error": "Os polígonos devem ter pelo menos 3 nós",
  "linestring_edit_error": "As linhas devem ter pelo menos 2 nós",
  "unknown_edit_error": "Ocorreu um erro desconhecido",
  "billing_error": "Houve um problema com a cobrança do seu projeto",
  "service_unavailable": "Este serviço não está disponível no momento, entre em contato com um administrador do projeto",
  "three_nested": "Você não pode criar uma pasta com mais de 3 níveis de profundidade",
  "error": "Erro",
  "invalidLink": "Link inválido",
  "error_boundaries": {
    "title_large": "Opa! Algo deu errado.",
    "title_small": "Algo deu errado!",
    "error_message": "Algo deu errado e nossa equipe foi alertada. Se o problema persistir, entre em contato com o suporte em ",
    "error_code": "Código de erro: {{ code }}",
    "contact": "Entre em contato conosco",
    "refresh": "Atualizar",
    "reload": "Recarregue",
    "webgl_error_title": "Erro WebGL detectado",
    "webgl_error_message": "Seu navegador ou dispositivo não oferece suporte ao WebGL, o que é necessário para visualizar este plano.",
    "webgl_support_message": "Você pode encontrar orientação sobre como ativar o WebGL aqui: ",
    "webgl_error_contact": "Se o problema persistir, entre em contato com o suporte em ",
    "version_error_title": "Uma nova versão do Iventis está disponível",
    "version_error_message": "Atualize seu navegador para carregar a versão mais recente do Iventis.",
    "connection_error_title": "Erro de conexão",
    "connection_error_message": "Houve um problema com sua conexão. Verifique sua conexão com a Internet e tente novamente."
  },
  "digital_twin": {
    "capacity": "Capacidade de servidor insuficiente para o gêmeo digital. Tente novamente mais tarde ou entre em contato com {{ supportEmail }} para obter mais informações",
    "occupied": "O gêmeo digital está atualmente ocupado. Tente novamente mais tarde.",
    "afk": "Você foi desconectado do gêmeo digital devido à inatividade.",
    "connection_failed": "Falha na conexão com o serviço digital twin. Tente novamente mais tarde.",
    "generic": "Houve um problema com o serviço digital twin. Por favor, tente novamente mais tarde."
  },
  "custom_network_error": {
    "create": {
      "title": "Falha ao criar {{ entity }}",
      "message": "A criação de {{ entity }} não foi salva"
    },
    "update": {
      "title": "Falha ao atualizar {{ entity }}",
      "message": "Suas alterações na {{ entity }} não foram salvas"
    },
    "import_error": {
      "title": "Falha ao importar {{ entity }}",
      "message": "Suas {{ entity }} não foram importadas"
    },
    "export_error": {
      "title": "Falha ao exportar {{ entity }}",
      "message": "Sua {{ entity }} não foi exportada"
    },
    "delete_error": {
      "title": "Falha ao excluir {{ entity }}",
      "message": "Sua {{ entity }} não foi excluída"
    },
    "generic": {
      "title": "Falha em {{ action }}",
      "message": "Sua solicitação para {{ action }} não foi bem-sucedida"
    }
  }
}